export default __webpack_public_path__ + "static/media/main_intro_web.a410c40b.mp4";